import { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Logo from '../../components/Logo';
import api from '../../api';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from || '/matchcodes';

  // Check for existing JWT token on component mount
  useEffect(() => {
    const token = localStorage.getItem('jwt');
    if (token && token.length > 0) {
      // User already has a valid token, redirect to main app
      navigate('/matchcodes', { replace: true });
    }
  }, [navigate]);

  const onLogin = () => {
    if (email.length > 0 && password.length > 0) {
      api.post(`/login`, { email, password })
        .then((res) => {
          const token = res.data.token;
          localStorage.setItem("jwt", token);
          window.showToast('Login Successfully !', 'success');
          navigate(from);
        }).catch((err) => {
          const msg = err.response?.data?.error || 'Login failed';
          window.showToast(msg, 'error');
        });
    } else {
      window.showToast("All fields required.", 'warning');
    }
  };

  return (
    <div className="App">
      <Logo />
      <header className="App-header">
        <div>
          <p style={{color:'black'}}>
            MFG QR Match - Login
          </p>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextField 
                id="outlined-basic" 
                value={email} 
                onChange={(e) => setEmail(e.target.value)}
                label="Email Address" 
                variant="outlined"
                onKeyPress={(e) => e.key === 'Enter' && onLogin()}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField 
                id="outlined-basic" 
                value={password} 
                onChange={(e) => setPassword(e.target.value)}
                label="Password" 
                type="password" 
                variant="outlined"
                onKeyPress={(e) => e.key === 'Enter' && onLogin()}
              />
            </Grid>
            <Grid item xs={12}>
              <Button variant="contained" onClick={onLogin}>Login</Button>      
            </Grid>
          </Grid>
        </div>
      </header>
    </div>
  );
};

export default Login; 